const wrapStateWithUndoHistory = state => {
  return {
    present: state
  };
};

const isWrapped = state => state.present;

const undoRedo = reducer => {
  return function(incomingState, action) {
    // Convert state to a proper wrapped state if we need to
    const state = isWrapped(incomingState) ? incomingState : wrapStateWithUndoHistory(incomingState);

    // Apply the reducer
    const newPresent = reducer(state.present, action);

    // If the result is no change to the state, just
    // return our existing state
    if (newPresent === state.present) {
      return state;
    }

    // Otherwise, we need to update our states...
    return {
      present: newPresent
    };
  };
};

export default undoRedo;
